<cipo-dialog-header title="assignments.reorderRoles" fullScreen="never" />
<mat-dialog-content>
    <p class="m-t-md">{{ userName }}</p>
    <div cdkDropList class="role-list" (cdkDropListDropped)="drop($event)">
        @for (role of roles(); track role.key) {
            <div
                cdkDrag
                class="role-item cipo--border--solid cipo--border-radius--xs p-a-sm m-b-sm"
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px">
                <mat-icon aria-hidden="true" class="material-symbols-outlined">drag_pan</mat-icon>
                <span>{{ role.value }}</span>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ "general.cancel" | translate }}</button>
    <button mat-raised-button color="primary" (click)="save()">{{ "general.save" | translate }}</button>
</mat-dialog-actions>
